import Upsertable from '@/models/Upsertable'
import Customer from '@/models/Customer'
import Harvest from '@/models/Harvest'
import Field from '@/models/Field'
import { useFarmStore } from '@/stores/farmStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Farm extends Upsertable {
  static store() {
    return useFarmStore()
  }

  store() {
    return Farm.store()
  }

  static all() {
    return Farm.store().getAll
  }

  static find(uuid) {
    const obj = Farm.store().find(uuid)
    let farm = new Farm()
    return Object.assign(farm, obj)
  }

  customer() {
    let customer = Customer.store().find(this.customer_uuid)
    return Object.assign(new Customer(), customer)
  }

  fields() {
    let fields = Field.find_all_by_farm_uuid(this.uuid)
    let fieldObjects = []
    fields.forEach(function (item) {
      fieldObjects.push(Object.assign(new Field(), item))
    })
    return fieldObjects
  }

  harvests() {
    let harvestObjects = []
    let harvests = Harvest.store().findByFarmUuid(this.uuid)
    harvests.forEach(function (item) {
      harvestObjects.push(Object.assign(new Harvest(), item))
    })
    return harvestObjects
  }
}

useModelName(Farm, "Farm")
ModelRegistry.register(Farm, "Farm")